// String for the CNCC product landing page.

// Pro Tip: if you're searching for text to find out where something is
// rendered, consider using React DevTools instead.

import type {Images, Strings} from "./types.ts";

const strings: Strings = {
    ctaGetStarted: "Empieza con Khan Academy",

    title: "Khan Academy está alineado al Currículo Nacional de Educación Básica!",

    whatIsIt: "¿Qué es el Currículo Nacional?",

    whatIsItDescription:
        '"El Currículo Nacional es el documento marco de la política educativa de la educación básica que contiene los aprendizajes que se espera que los estudiantes logren durante su formación básica, en concordancia con los fines y principios de la educación peruana, los objetivos de la educación básica y el Proyecto Educativo Nacional.\nEste documento establece el Perfil de Egreso de la Educación Básica, las competencias nacionales y sus progresiones desde el inicio hasta el fin de la educación básica, así como sus niveles esperados por ciclo, nivel y modalidades. Además, contiene orientaciones para la evaluación formativa y la diversificación curricular."',

    whyAlign: "¿Por qué alinearnos al Currículo Nacional?",
    whyAlignDescription:
        "Desde Khan Academy queremos asegurar que apoyemos el desarrollo de estas competencias, habilidades y conocimientos para los alumnos de 1º de Primaria hasta 5º de Secundaria. Para hacerlo, hemos mapeado nuestros contenidos de matemáticas a los desempeños, capacidades y competencias detallados en el Currículo Nacional. A los estudiantes y maestros de Perú les ofrece la facilidad de encontrar contenido relevante a su grado y asimismo identificar las competencias que están trabajando con ello.\nEn colaboración con una reconocida ONG de educación en Perú, Khan Academy ha mapeado su contenido frente a los desempeños por grado, logrando cumplir con un promedio de más de 85% de ellos. Continuaremos actualizando este contenido para alcanzar el 100% de cobertura.",

    howCanWeHelp: "Cómo podemos ayudar?",

    waysWeCanHelp: [
        [
            "Maestros",
            "Encontrar contenido excepcional alineado al Currículo Nacional",
            "Identificar las competencias de matemáticas trabajadas en cada ejercicio, video o artículo",
            "Asignar videos, artículos y ejercicios",
            "Ofrecer práctica personalizada a sus estudiantes",
            "Monitorear y acompañar el progreso de sus estudiantes",
        ],
        [
            "Autoridades educativas y colegios",
            "Utilizar Khan Academy para ayudar a los estudiantes y maestros a alcanzar los desempeños y competencias de matemáticas del Currículo Nacional",
            "Implementar Khan Academy en los colegios",
            "Promover el uso de las nuevas tecnologías en la clase,  junto con contenido cuidadosamente elaborado",
            "Fomentar el aprendizaje autónomo en los alumnos y la comunidad educativa",
        ],
    ],

    kaAndIt: "¿Cómo está alineado Khan Academy al Currículo Nacional?",

    kaAndItDescription:
        "Sabemos que los colegios y los maestros siempre quieren contenido de calidad para utilizar con sus estudiantes. Con la introducción de un nuevo currículo es más importante aún contar con los materiales adecuados. Para responder a ello, hemos empezado este proceso de alineación, ofreciendo una nueva organización de nuestra plataforma para corresponder a los grados educativos de Perú, y también nuevas maneras de buscar contenido apropiado.",

    kaAndItBulletPoints: [
        [
            "1. Contenido alineado a los desempeños de matemáticas",
            "Cada video, artículo y ejercicio está mapeado según los desempeños especificados para 1º de Primaria hasta 5º de Secundaria\nAdemás, se puede identificar fácilmente las competencias de matemáticas desarrolladas por el contenido",
        ],
        [
            "2. Nuevo diseño",
            "La plataforma ahora está organizada por los grados peruanos, facilitando la búsqueda de contenidos para los alumnos",
        ],
        [
            "3. Búsqueda por competencia",
            "Se puede buscar contenidos específicos basados en las competencias que el maestro quiere trabajar",
        ],
    ],

    gettingStarted: "¿Cómo comienzo?",

    gettingStartedDescription:
        "Khan Academy es reconocido como un recurso de calidad a nivel mundial para maestros. Ya hay cientos de miles usuarios de Khan a nivel nacional en Perú. Nuestro proceso de alineamiento al Currículo Nacional es clave en este momento de implementación de un nuevo currículo. Queremos acompañarte en este camino. Empieza a usar Khan Academy con tus estudiantes y comprueba tú mismo la nueva alineación.",

    ctaLearnMore: "Conoce más",
    ctaLearnMore2: "Quiero saber más",

    htmlTitle:
        "Khan Academy está alineado al Currículo Nacional de Educación Básica!",

    officialLink: "http://www.minedu.gob.pe/curriculo/",
    kaResourcesLink: "https://es.khanacademy.org/resources/teacher-essentials",
    signupUrl: "https://es.khanacademy.org/signup?continue=/teacher/dashboard",
};

export const images: Images = {
    hero: "/images/bncc/hero-cncc.png",
    map: "/images/bncc/map-cncc.png",
    footer: "/images/bncc/get-started-cncc.png",
    kaAndItBulletPoints: [
        "/images/bncc/alignment-v2-cncc.png",
        "/images/bncc/curriculum-v2-cncc.png",
        "/images/bncc/search-v2-cncc.png",
    ],
};

export default strings;
